import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation('home');

  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20flowing%20abstract%20gradient%20waves%20in%20warm%20terracotta%20coral%20and%20cream%20tones%2C%20smooth%20organic%20shapes%2C%20minimalist%20digital%20art%2C%20luxurious%20textured%20background%2C%20soft%20ethereal%20lighting%2C%20clean%20modern%20aesthetic%2C%20fluid%20dynamic%20composition&width=1800&height=1200&seq=cta-abstract-waves&orientation=landscape"
        alt="Optimisez vos données"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/50 via-foreground-900/35 to-foreground-900/55"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 md:px-6 w-full max-w-2xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 tracking-wide uppercase mb-4">
          {t('final_cta_title')}
        </h2>

        <p className="text-sm md:text-base text-background-100/90 font-light leading-relaxed mb-2">
          {t('final_cta_subtitle_line1')}
        </p>
        <p className="text-sm md:text-base text-background-100/90 font-light leading-relaxed mb-10">
          {t('final_cta_subtitle_line2')}
        </p>

        {/* Main CTA Button */}
        <div className="flex flex-col items-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 px-8 py-4 bg-foreground-900 text-background-50 text-sm md:text-base font-medium rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
              <i className="ri-shopping-bag-line text-xs"></i>
            </span>
            {t('final_cta_button')}
            <span className="w-7 h-7 rounded-full border border-background-50/20 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
              <i className="ri-arrow-right-up-line text-xs"></i>
            </span>
          </a>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="text-sm text-background-50/80 hover:text-background-50 underline underline-offset-4 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('final_cta_secondary')}
          </a>

          <p className="text-xs text-background-50/60 mt-4">
            {t('final_cta_urgency')}
          </p>
        </div>
      </div>
    </section>
  );
}